import * as React from 'react';
import { useEffect } from 'react';
import { BeKindSection } from '../../components/block-be-kind';
import { IngredientLibraryHomePageSection, InstagramFeed } from '../../components/homepageComponents';
import { Layout } from '../../components/layout';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { styled } from '../../styles/stitches.config';
import { Seo } from '../../components/seo';

const Ingredients = () => {
    useEffect(() => {
        document.getElementsByTagName('body')[0].style.overflow = "auto";
    }, []);
    const IngredientsContainer = styled('div', {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        backgroundColor: '#f8f5f1',
        '@bp1': {
            gridTemplateColumns: '1fr',
            padding: '80px 0',
        },
        '@bp2': {
            gridTemplateColumns: '1fr 1fr',
            padding: '80px 40px',
        },
        '@bp3': {
            gridTemplateColumns: '1fr 1fr 1fr',
            padding: '80px 80px',
        },
        '& .MuiPaper-elevation1': {
            backgroundColor: '#f8f5f1',
            boxShadow: 'none !important',
        },
        '& .MuiAccordion-root:before': {
            height: '0px !important',
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '0px !important',
        },
        '& .MuiAccordionSummary-content': {
            fontFamily: '$default',
            fontSize: '17px',
            fontWeight: '800',
            letterSpacing: '0.1em',
            alignItems: 'start',
            textTransform: 'capitalize',
            margin: '0px !important',
            padding: '12px 0',
            justifyContent: 'space-between',
        },
        '& .MuiAccordionDetails-root': {
            fontFamily: '$lato',
            fontSize: '18px',
            lineHeight: '29px',
            color: '#585d6c',
            padding: '0 24px 24px 24px',
        },
        '& .Mui-expanded': {
            backgroundColor: '#f3eee7',
            margin: '0px !important',
        },
        '& .MuiAccordionSummary-root': {
            alignItems: 'start',
            padding: '12px 24px',
        },
        '& .arrowhead': {
            padding: '0 0 0 48px',
        },
    });

    return (
        <Layout>
            <Seo
                title={'Ingredients - Better Days Skin Co.'}
            />
            <IngredientLibraryHomePageSection showButton={false} />
            <IngredientsContainer>
                <Accordion>
                    <AccordionSummary>
                        <div>CHAMOMILE RECUTITA FLOWER EXTRACT</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        This plant-based antioxidant has potent anti-inflammatory powers that greatly reduce redness and calm irritation. Chamomile is also one of the oldest and most well-documented medicinal plants in the world. It works by inhibiting the chemical release of histamine in our cells. That is to say, Chamomile has anti-histamine properties. Studies show that it is 60% as effective as 0.25% hydrocortisone creams.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>NIACINAMIDE (VITAMIN B3)</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        This multi-tasking superstar ingredient refines pores and skin texture, brightens dull skin and fades pigmentation, smooths the appearance of wrinkles and strengthens skin barrier. It stimulates our natural collagen and ceramide production which restores our skin cells and prevents dehydration.It can even balance our sebum levels by slowing down oil production. Works well with antioxidants like CoQ10.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>UBIQUINONE (COQ10)</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        A vital antioxidant found naturally in our cells, it activates cellular metabolism and provides energy to our skin cells for cellular repair and regeneration. It stimulates natural collagen and elastin production to smooth fine lines and firm skin. It helps prevent fine lines and possibly reduces the depth of wrinkles. Works well with Niacinamide.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>CAMELLIA SINENSIS (GREEN TEA) LEAF EXTRACT</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Green tea is one of the most well researched natural ingredients. Rich in protective antioxidants, this plant extract contains polyphenols and is anti-inflammatory and anti-microbial, which is great for soothing skin and providing relief for sensitive and acenic skin. Its strong antioxidant properties protect against UV and free radical damage.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>ALOE VERA JUICE LIQUID EXTRACT</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Soothes skin with its anti-inflammatory and anti-bacterial properties. It is a healing and hydrating source of antioxidants,vitamins, minerals and amino acids for wound healing and skin regeneration.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>VITIS VINIFERA (GRAPE) SEED OIL</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Grape Seed oil has moisturising and nourishing properties because of its high linoleic acid content and vitamin E. It is anti-inflammatory and non-comedogenic with potent antioxidant properties - helps improve the skin barrier and reduce the appearance of acne scars and hyperpigmentation. It is a non-fragrant plant based oil that is extracted by pressing grape seeds.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>SIMMONDSIA CHINENSIS (JOJOBA) SEED OIL</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        A non-fragrant plant based oil that enhances skin’s restorative properties. It contains essential fatty acid that helps lock in moisture, keeping the skin supple and resilient. Jojoba is also naturally antibacterial, antifungal and anti-inflammatory. Because jojoba oil is able to penetrate all the way down to the skin matrix, it can help active ingredients like salicylic acid to work better.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>CERAMIDES</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Ceramides are skin-identical ingredients that make up over 50% of skin&apos;s composition.They reinforce your skin’s barrier and improve moisture retention. Resulting in plumper, smoother skin with fewer visible lines and wrinkles, and improves sensitivity. Ceramides are most effective when combined with other skin-replenishing ingredients like glycerin, amino acids, grape seed oil etc.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>SALICYLIC ACID (BHA)</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Salicylic acid is the gold standard for refining pores by diminishing and preventing blackheads and whiteheads. Salicylic acid penetrates the skin to unclog pores and at the same time, exfoliates dead skin cells.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>L-LACTIC ACID (PHA)</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        L-Lactic Acid is a gentle exfoliating acid that fades general discolouration without irritation by attracting hydration. Lactic acid hydrates the skin by increasing the natural barrier lipids in the outer layer of the skin, which is why this acid is much more gentle compared to Glycolic acid.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>GLYCERIN</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Glycerin attracts moisture to the skin, it is classified as an humectant that hydrates skin by mimicking our skin’s natural moisturising factor (NMF), which keeps the lipids between our skin cells in a healthy state, protects against irritation and helps restore the skin barrier. It also enhances the penetration of other ingredients.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>POLUGONUM CUSPIDATUM (JAPANESE KNOTWEED) ROOT EXTRACT</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        A medicinal herb in Traditional Chinese Medicine (TCM), this plant root extract is an excellent source of resveratrol which is a powerful antioxidant that can inhibit AGEs (Advanced Glycation Endproducts - basically sugar-fuelled collagen damage in our skin). It is also anti-microbial and anti-inflammatory which helps to soothe redness and skin irritation.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>RED PANAX GINSENG EXTRACT</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Korean Red Ginseng is a prominent herb used in both Traditional Chinese Medicine (TCM) and Korean Hanbang to restore vital energy. In skincare, it has the same energising factors to revitalise our complexion and brighten up a tired and dull face. Ginseng has incredible antioxidant compounds and B vitamins which delivers nutrients with anti-aging and anti-inflammatory effects. It boosts our skin health by stimulating collagen production and defending against free radical damage.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>SODIUM HYALURONATE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Sodium Hyaluronate is the sodium form of hyaluronic acid (HA), which can be found naturally in the skin. It can bind up to 1000 times its own weight in water, but its sodium form means it can penetrate deeper into the skin and is actually a more stable version of HA. It helps replace moisture loss, increase hydration, smooth texture created by fine lines and plumps up skin.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>ALLANTOIN</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        A multi-purpose healing ingredient with potent calming and regenerative properties. It also moisturises by acting as an emollient to prevent trans-epidermal water loss (TEWL) and protects against dryness and irritation.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>GINKGO BILOBA LEAF EXTRACT</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Classified as a &quot;living fossil&quot;, Ginkgo leaves have been used as an antimicrobial treatment for skin infections dating back to 16th Century China. In modern day skincare, the Gingko leaf is harnessed for its excellent antioxidant properties and anti-microbial and anti-inflammatory powers. It reduces oxidative stress with a soothing effect that is particularly beneficial to sensitive skin. It also improves moisture retention and skin texture.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>SODIUM PCA (PYRROLIDONE CARBOXYLIC ACID)</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        A naturally occurring component of human skin, sodium PCA forms about 12% of your skin’s natural moisturising factor (NMF). Sodium PCA is an important humectant in skincare. It is water binding and moisturising and can hold several times its weight in water. It helps restore an impaired barrier, prevent premature ageing, and helps to reduce inflammation within your skin’s tissues.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>SODIUM LACTATE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Sodium salt of lactic acid. Used primarily as a hydrating and buffering agent (to adjust a product’s pH value).                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>ARGININE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        An essential amino acid with antioxidant properties, protects the skin from free radicals, increases the skin’s visible hydration levels and restores visible skin damage.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>ASPARTIC ACID</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        A non-essential amino acid (important building block of collagen and elastin) that hydrates the skin. It is also used to set the pH of the cosmetic product.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>PCA</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        PCA (which stands for pyrrolidone carboxylic acid), is an ingredient derived from amino acids that serves as a humectant and is part of the natural moisturizing factor (NMF).                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>GLYCINE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        An amino acid used as a texturizer in skincare formulations. It makes up approximately 30% of the collagen molecule.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>ALANINE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        A non-essential amino acid (a building block of skin proteins like collagen or elastin) that hydrates the skin.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>SERINE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Serine is an amino acid that is often used as the role of a natural moisturizing agent in skincare formulas. It's a non-essential amino acid (meaning that our body can synthesize it) and serves as a water-binding ingredient.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>VALINE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        Valine is an essential amino acid that hydrates and conditions the skin.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>PROLINE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        A non-essential amino acid (meaning that our body can produce it) that's also one of the major building blocks of collagen. it might be able to improve wrinkles when combined with other amino acids like glycine.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>THREONINE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        An essential amino acid that&apos;s also a key building block of collagen and elastin. important for the formation of collagen and elastin.
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>ISOLEUCINE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                    A branch-chained, essential amino acid that can be found in things like almond, cashew or soy protein. it&apos;s a skin-identical ingredient and moisturizer. It also seems to be useful as a barrier repair ingredient.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>HISTIDINE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                    A semi-essential amino acid that soothes the skin and has antioxidant properties.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>PHENYLALANINE</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                    An essential amino acid that hydrates and conditions the skin.                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>XANTHAN GUM</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>

                    Serves as a texturizer, carrier agent and gelling agent in skincare formulations. It also stabilizes and thickens formulations                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary>
                        <div>BUTYLENE GLYCOL</div><div className="arrowhead">&#8964;</div>
                    </AccordionSummary>
                    <AccordionDetails>
                    Humectant, solvent, and emollient that retains moisture, dissolves ingredients, improves application and enhances texture. It improves penetration of active ingredients, which, as a result, helps the product perform more effectively. It can also be used as a preservative. When combined with other skin-soothing ingredients like allantoin, niacinamide etc, it can help cushion the exfoliating action from Salicylic acid and L-Lactic acid.                    </AccordionDetails>
                </Accordion>
            </IngredientsContainer >
            <BeKindSection />
            <InstagramFeed />
        </Layout >
    )
}

export default Ingredients;
